export default __webpack_public_path__ + "static/media/thumbnail.6fd09c18.png";